import { type ArticleParams } from '~/types/Article';
import type { Strapi5ResponseMany } from '~/types/Strapi';

class StrapiArticleService {
    async retrieveRecentArticles(limit: number | null = null): Promise<Strapi5ResponseMany<ArticleParams>> {
        const { find } = useStrapi();

        const _articles: Strapi5ResponseMany<ArticleParams> = await find<ArticleParams>('articles', {
            populate: ['seo', 'image'],
            sort: ['createdAt:desc'],
            pagination:
                limit !== null
                    ? {
                          limit,
                          start: 0,
                      }
                    : undefined,
        });

        return _articles;
    }

    async retrieveArticle(uuid: string): Promise<ArticleParams> {
        const { find } = useStrapi();

        const _articles: Strapi5ResponseMany<ArticleParams> = await find<ArticleParams>('articles', {
            filters: { uuid },
            populate: ['seo', 'seo.shareImage', 'image'],
        });

        if (_articles.data.length) {
            return _articles.data[0];
        } else {
            throw new Error('Article not found');
        }
    }
}

export default new StrapiArticleService();
